module.exports = __webpack_public_path__ + "img/1_2-finanziario-attico-1.fe1158d1.png";